class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cart_icon = document.querySelector('#cart-icon-bubble-short')?'cart-icon-bubble-short':'cart-icon-bubble';
    this.cart_icon_mobile = document.querySelector('#cart-icon-bubble--mobile-short')?'cart-icon-bubble--mobile-short':'cart-icon-bubble--mobile';
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    document.querySelectorAll(`[id*="cart-icon-bubble"]`).forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('active');
      this.classList.add('animate');
      document.body.classList.add('cart-drawer-open');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    if(document.querySelectorAll('.popup-modal.active').length == 0){
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');
    }
  }

  close() {
    this.classList.remove('animate');
    setTimeout(() => {
      this.classList.remove('active');
      document.body.classList.remove('cart-drawer-open');
      if(document.querySelectorAll('.popup-modal.active').length == 0){
        document.body.classList.remove('overflow-hidden');
        document.body.style.paddingRight = '';
      }
    }, 500);
    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(sectionElement) sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if(section.id == 'cart-free-delivery' && document.querySelector('#product-page-free-delivery')){
        document.querySelector('#product-page-free-delivery').innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
      if(section.id == this.cart_icon && document.querySelector('.footer-sticky-nav__item__icon .cart-count-bubble')){
        const parser = new DOMParser();
        const bubble = parser.parseFromString(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector), 'text/html');
        var ib = bubble.querySelector('.cart-count-bubble')?bubble.querySelector('.cart-count-bubble').innerHTML : '' ;
        document.querySelector('.footer-sticky-nav__item__icon .cart-count-bubble').innerHTML = ib;
      }
    });

    // Cart drawer is intentionally NOT opened after add-to-cart.
    // The custom notification bar in main-product.liquid handles the feedback.
    // setTimeout(() => { this.open(); });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: this.cart_icon,
      },
      {
        id: this.cart_icon_mobile
      },
      {
        id: 'cart-free-delivery'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    this.cart_icon = document.querySelector('#cart-icon-bubble-short')?'cart-icon-bubble-short':'cart-icon-bubble';
    this.cart_icon_mobile = document.querySelector('#cart-icon-bubble--mobile-short')?'cart-icon-bubble--mobile-short':'cart-icon-bubble--mobile';
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: this.cart_icon,
        section: this.cart_icon,
        selector: '.shopify-section',
      },
      {
        id: this.cart_icon_mobile,
        section: this.cart_icon_mobile,
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('submit', function(e) {
  const form = e.target;
  if (!form || form.tagName !== 'FORM') return;
  const action = form.getAttribute('action') || '';
  if (!action.includes('/cart/add')) return;
  const idField = form.querySelector('input[name="id"]');
  if (!idField || !idField.value) return;

  // Override id with selected variant from card-variant-selects (color picker on cards)
  try {
    const productCard = form.closest('[id^="product-"]') || form.closest('product-form');
    const selects = productCard && productCard.querySelector('card-variant-selects');
    if (selects) {
      const json = selects.querySelector('script[type="application/json"]');
      if (json) {
        const variants = JSON.parse(json.textContent);
        const checked = Array.from(selects.querySelectorAll('fieldset')).map(fs => {
          const c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
        const selectVals = Array.from(selects.querySelectorAll('select')).map(s => s.value);
        const opts = checked.length ? checked : selectVals;
        if (opts.length && opts.every(v => v !== null)) {
          const match = variants.find(v => opts.every((val, i) => v['option' + (i+1)] === val));
          if (match) {
            idField.value = match.id;
            console.log('[cart] variant override:', match.id, opts);
          }
        }
      }
    }
  } catch (err) { console.warn('[cart] variant detect error:', err); }

  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

  const submitBtn = form.querySelector('[type="submit"]');
  const spinner = form.querySelector('.loading-overlay__spinner');
  if (submitBtn) {
    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('loading');
  }
  if (spinner) spinner.classList.remove('hidden');

  const cartDrawer = document.querySelector('cart-drawer');
  const formData = new FormData(form);
  formData.delete('return_to');
  formData.delete('sections');
  formData.delete('sections_url');

  const sectionIds = ['cart-drawer','cart-icon-bubble','cart-icon-bubble-short','cart-icon-bubble--mobile','cart-icon-bubble--mobile-short','cart-free-delivery'];
  formData.append('sections', sectionIds.join(','));
  formData.append('sections_url', '/');

  // Detect whether drawer was empty BEFORE the add — empty→populated transitions
  // are flaky when relying on the section response embedded in /cart/add.js,
  // so we'll refetch a fresh section in that case.
  const wasEmpty = !!(cartDrawer && cartDrawer.classList.contains('is-empty'));

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
    body: formData
  })
  .then(r => r.json())
  .then(addResp => {
    console.log('[cart] add resp:', addResp);
    if (addResp.status && addResp.status !== 200) {
      console.error('[cart] add error:', addResp);
      alert(addResp.description || addResp.message || 'Kon product niet toevoegen');
      return null;
    }
    const sections = addResp.sections || {};
    // Always refetch the cart-drawer + cart-free-delivery sections in a separate
    // GET so they reflect the post-add state authoritatively. This fixes the
    // first-add-broken / second-add-normal bug where sections embedded in the
    // POST response could lag the mutation.
    const sectionsToRefetch = ['cart-drawer','cart-free-delivery'].join(',');
    return Promise.all([
      fetch('/cart.js').then(r => r.json()),
      fetch('/?sections=' + sectionsToRefetch).then(r => r.json()).catch(() => ({}))
    ]).then(([cart, freshSections]) => {
      // Merge: prefer freshly-fetched sections (authoritative) over add response
      const merged = Object.assign({}, sections, freshSections || {});
      console.log('[cart] cart.js item_count:', cart.item_count, 'wasEmpty:', wasEmpty, 'merged section keys:', Object.keys(merged));
      return { cart, sections: merged };
    });
  })
  .then(data => {
    if (!data) { console.warn('[cart] no data, abort UI update'); return; }
    const { cart, sections } = data;
    console.log('[cart] updating UI, drawer found:', !!cartDrawer);
    updateCartCount(cart.item_count, sections);
    if (cartDrawer) {
      if (cart.item_count > 0) {
        cartDrawer.classList.remove('is-empty');
      } else {
        cartDrawer.classList.add('is-empty');
      }
      if (sections['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newCartDrawer = parsed.querySelector('cart-drawer');
        const newInnerHTML = parsed.querySelector('#CartDrawer');
        const target = document.getElementById('CartDrawer');
        // sync is-empty class FIRST so CSS is correct before the new DOM is painted
        if (newCartDrawer) {
          if (newCartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.add('is-empty');
          } else {
            cartDrawer.classList.remove('is-empty');
          }
        }
        if (newInnerHTML && target) target.innerHTML = newInnerHTML.innerHTML;
        // Also sync is-empty on the inner cart-drawer-items custom element
        const newItems = parsed.querySelector('cart-drawer-items');
        const curItems = cartDrawer.querySelector('cart-drawer-items');
        if (newItems && curItems) {
          if (newItems.classList.contains('is-empty')) curItems.classList.add('is-empty');
          else curItems.classList.remove('is-empty');
        }
        // Force a layout flush so the freshly-injected DOM is measured before
        // the open() transition kicks in — prevents the first-add layout glitch.
        // eslint-disable-next-line no-unused-expressions
        cartDrawer.offsetHeight;
      }
      if (sections['cart-free-delivery']) {
        const fd = document.getElementById('cart-free-delivery');
        if (fd) {
          const parsed = new DOMParser().parseFromString(sections['cart-free-delivery'], 'text/html');
          const inner = parsed.querySelector('.shopify-section');
          if (inner) fd.innerHTML = inner.innerHTML;
        }
      }
      // cartDrawer.open() — intentionally disabled; notification bar handles feedback.
      const scrollArea = cartDrawer.querySelector('cart-drawer-items') || cartDrawer.querySelector('.drawer__footer-content');
      if (scrollArea) scrollArea.scrollTop = 0;
      showCartAddedMessage();
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: cart });
    }
  })
  .catch(err => console.error('[cart] error:', err))
  .finally(() => {
    if (submitBtn) {
      submitBtn.removeAttribute('aria-disabled');
      submitBtn.classList.remove('loading');
    }
    if (spinner) spinner.classList.add('hidden');
  });
}, true);

function updateCartCount(count, sections) {
  document.querySelectorAll('.cart-count-bubble .header__button__bubble__count, .cart-count-bubble .body3-no-scale').forEach(el => {
    el.textContent = count;
  });
  document.querySelectorAll('[class*="ai-navbar-cart-count-"]').forEach(el => {
    if (count > 0) {
      el.textContent = count;
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  });
  ['cart-icon-bubble','cart-icon-bubble-short','cart-icon-bubble--mobile','cart-icon-bubble--mobile-short'].forEach(id => {
    const el = document.getElementById(id);
    if (!el || !sections[id]) return;
    const parsed = new DOMParser().parseFromString(sections[id], 'text/html');
    const inner = parsed.querySelector('.shopify-section') || parsed.body.firstElementChild;
    if (inner) el.innerHTML = inner.innerHTML;
  });
  const footerBubble = document.querySelector('.footer-sticky-nav__item__icon .cart-count-bubble');
  if (footerBubble) footerBubble.textContent = count;
}

function showCartAddedMessage() {
  // Floating toast — visible on every page (homepage cards, product page, etc.)
  let toast = document.getElementById('woolina-cart-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'woolina-cart-toast';
    toast.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0">' +
      '<path d="M20 6L9 17l-5-5"></path></svg>' +
      '<span>Succesvol toegevoegd aan uw winkelwagen!</span>';
    Object.assign(toast.style, {
      position:        'fixed',
      bottom:          '-80px',
      left:            '50%',
      transform:       'translateX(-50%)',
      display:         'flex',
      alignItems:      'center',
      gap:             '10px',
      backgroundColor: '#28a745',
      color:           '#fff',
      fontWeight:      '500',
      fontSize:        '15px',
      padding:         '12px 24px',
      borderRadius:    '6px',
      boxShadow:       '0 4px 12px rgba(0,0,0,0.15)',
      zIndex:          '9999999',
      transition:      'bottom 0.4s cubic-bezier(0.175,0.885,0.32,1.275)',
      whiteSpace:      'nowrap',
      pointerEvents:   'none',
    });
    document.body.appendChild(toast);
  }
  // Slide up
  toast.style.bottom = '30px';
  clearTimeout(window._woolinaCartToastTimer);
  window._woolinaCartToastTimer = setTimeout(() => {
    toast.style.bottom = '-80px';
  }, 2000);
}

document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;
  cartDrawer.addEventListener('transitionend', function(e) {
    if (!cartDrawer.classList.contains('active')) {
      const msg = cartDrawer.querySelector('.cart-added-toast');
      if (msg) msg.classList.remove('show');
    }
  });
});